import React, { useMemo } from "react";
const apiKey = "AIzaSyAN4FpvoTeToxAafc_OGlufckos2clD7_k";
const getUrl = (latitude, longitude, zoom) => {
  return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&zoom=${zoom}`;
};
function Map({
  value
}) {
  const {
    marker: {
      location
    },
    zoom
  } = value;
  const memoizedValue = useMemo(() => getUrl(location.lat, location.lng, zoom), [location.lat, location.lng, zoom]);
  return /*#__PURE__*/React.createElement("iframe", {
    style: {
      width: "100%",
      height: "100%",
      border: "0"
    },
    src: memoizedValue
  });
}
export default Map;
//# sourceMappingURL=Map.js.map